import React from 'react'
import trackLogo from '../../../Assets/Img/zeelogo.png'
import '../../../Assets/Style/TrackResults.scss'

const TrackResults = ({ trackResults }) => {
  // Format timestamp for display
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="track-results-container">
      {
        trackResults && trackResults.events && trackResults.events.length > 0 ? (
          <div className="track-results">
            <div className="shipment-addresses">
              <div className="address-section">
                <h3>Sender Address</h3>
                <p>{trackResults.sender_address}</p>
              </div>
              <div className="address-section">
                <h3>Receiver Address</h3>
                <p>{trackResults.receiver_address}</p>
              </div>
            </div>

            <div className="tracking-timeline">
              <h2>Tracking History</h2>
              <div className="timeline">
                {trackResults.events.map((event, index) => (
                  <div key={event.id} className={`timeline-item ${index === trackResults.events.length - 1 ? 'latest' : ''}`}>
                    <div className="timeline-marker">
                      <div className="timeline-dot"></div>
                      {index !== trackResults.events.length - 1 && <div className="timeline-line"></div>}
                    </div>
                    <div className="timeline-content">
                      <div className="timeline-time">{formatDate(event.timestamp)}</div>
                      <div className="timeline-description">{event.description}</div>
                      {event.status_code && (
                        <div className="timeline-status-code">Status: {event.status_code}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="empty-track-state">
            <img src={trackLogo} alt="Track shipment" className="track-illustration" />
            <h2>Enter Track Details</h2>
            <p>Please enter your tracking number above to view your shipment details and tracking history.</p>
          </div>
        )
      }
    </div>
  )
}

export default TrackResults